import { render, staticRenderFns } from "./makCustom.vue?vue&type=template&id=22aefb82&scoped=true"
import script from "./makCustom.vue?vue&type=script&lang=js"
export * from "./makCustom.vue?vue&type=script&lang=js"
import style0 from "./makCustom.vue?vue&type=style&index=0&id=22aefb82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aefb82",
  null
  
)

export default component.exports